import apiClient from '../utils/apiClient';
import {
  LOAD_ALL_CMS_REQUEST,
  LOAD_ALL_CMS_SUCCESS,
  LOAD_ALL_CMS_FAIL,

  CMS_DETAIL_REQUEST,
  CMS_DETAIL_SUCCESS,
  CMS_DETAIL_FAIL,

  UPDATE_CMS_REQUEST,
  UPDATE_CMS_SUCCESS,
  UPDATE_CMS_FAIL,

  CLEAR_ERRORS,
} from '../constants/cmsConstants';

// get all pages
export const getCmsPages = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ALL_CMS_REQUEST });
    const { data } = await apiClient.get(`/admin/static-pages`);
    dispatch({ type: LOAD_ALL_CMS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: LOAD_ALL_CMS_FAIL, payload: err });
  }
};

// get page detail
export const getPageDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: CMS_DETAIL_REQUEST });
    const { data } = await apiClient.get(`/admin/static-pages/${id}`);
    dispatch({ type: CMS_DETAIL_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: CMS_DETAIL_FAIL, payload: error?.response?.data?.errMessage || error.message || error });
  }
};

// update page
export const updatePage = (pageId, page_title, content, status) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CMS_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' } };
    const { data } = await apiClient.put(`/admin/static-page/${pageId}`, { pageId, page_title, content, status }, config);
    dispatch({ type: UPDATE_CMS_SUCCESS, payload: data?.success || data });
  } catch (error) {
    dispatch({ type: UPDATE_CMS_FAIL, payload: error?.response?.data?.errMessage || error.message || error });
  }
};

//clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
